import axios from "axios";

export async function uploadFileToSignedUrl(signedUrl: string, data: string) {
  const file = await (await fetch(data)).blob();
  await axios.put(signedUrl, file);
}
